export default __webpack_public_path__ + "static/media/gift.ef73df6d.png";